import { Injectable } from '@angular/core'

import { RaffleLot } from './raffle-lot'

@Injectable()
export class RaffleLotSerializer {
  fromJson(json: any): RaffleLot {
    const raffleLot = {
      ...json
    }

    return raffleLot
  }

  toJson(raffleLot: RaffleLot): any {
    return {
      ...raffleLot
    }
  }
}
